export const FIND_REALTOR_AUTHORIZATION = 'find_realtor_authorization';

export const EXPERIMENTS = [FIND_REALTOR_AUTHORIZATION];
